// src/api/apiClient.js

import axios from "axios";

// 1️⃣ BACKEND BASE URL
// const baseURL = "http://192.168.0.155:3000/api";
export const baseURL = "https://fytestaging.simplifyte.com/api";
// export const baseURL = "http://192.168.0.139:8000/api";
// export const baseURL = "http://192.168.10.6:8000/api";

// 2️⃣ CREATE AXIOS INSTANCE
const apiClient = axios.create({
  baseURL,
  headers: {
    Accept: "application/json",
    // "Content-Type": "application/json",
  },
});

// apiClient.interceptors.request.use((config) => {
//   console.log("ATTACHING TOKEN:", config.headers.Authorization);
//   return config;
// });

// 3️⃣ ADD TOKEN TO EVERY REQUEST AUTOMATICALLY
// apiClient.interceptors.request.use(
//   (config) => {
//     const token = "30|Hyv16CzzBiSyQrupdOwbi52M2kSftc49NDhmOLfg4800bfe1";
//     // const token = localStorage.getItem("token");
//     // console.log(token);
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error),
// );

export default apiClient;
